import React from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import { useInView } from '../hooks/useInView';

const Testimonials = () => {
  const sectionRef = useInView();
  const testimonials = [
    {
      name: 'João Pedro',
      role: 'Avaliação Google',
      avatar: 'JP',
      rating: 5,
      text: 'Profissionais muito bem capacitados e uma das melhores em mão de obra e peças de reposição.',
      date: '3 Mar 2023'
    },
    {
      name: 'Jose Gean',
      role: 'Avaliação Google',
      avatar: 'JG',
      rating: 5,
      text: 'Oficina top profissionais capacitado ótimo atendimento',
      date: '2 Nov 2023'
    },
    {
      name: 'Ademir dos Santos',
      role: 'Avaliação Google',
      avatar: 'AS',
      rating: 5,
      text: 'Bom local e com bons preços',
      date: '19 Nov 2023'
    },
    {
      name: 'Luciano Aparecido',
      role: 'Avaliação Google',
      avatar: 'LA',
      rating: 5,
      text: 'Box 50 e uma oficina mecânica de qualidade e compromisso com seus clientes de competência com o que faz ótimo trabalho preço bom e serviço de qualidade',
      date: '2 Nov 2024'
    },
    {
      name: 'Higor Dos Reis Silva',
      role: 'Avaliação Google',
      avatar: 'HS',
      rating: 5,
      text: 'Oficina top, ótimo atendimento, recomendo a quem procura serviço de qualidade e sem dor de cabeça 🫡',
      date: 'Há 36 semanas'
    },
    {
      name: 'Dudu Oliveira',
      role: 'Avaliação Google',
      avatar: 'DO',
      rating: 5,
      text: 'Excelentes profissionais, honestos , preço justo, serviço com excelência.',
      date: 'Há 36 semanas'
    }
  ];

  const getAvatarColor = (index) => {
    const colors = [
      'bg-blue-500',
      'bg-purple-500',
      'bg-green-500',
      'bg-orange-500',
      'bg-pink-500',
      'bg-indigo-500'
    ];
    return colors[index % colors.length];
  };

  return (
    <section id="depoimentos" className="py-20 bg-gradient-to-br from-gray-50 to-white" ref={sectionRef}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="animate-on-scroll text-center max-w-3xl mx-auto mb-16">
          <span className="text-accent font-semibold text-sm uppercase tracking-wider">Depoimentos</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-secondary-dark mt-3 mb-4">
            O Que Nossos Clientes Dizem
          </h2>
          <p className="text-gray-600 text-lg">
            A satisfação dos nossos clientes é nossa maior conquista. 
            Veja o que eles têm a dizer sobre nossos serviços.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`animate-on-scroll delay-${Math.min((index % 3 + 1) * 100, 300)} bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-accent/20 relative`}
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-accent/10">
                <FaQuoteLeft className="text-4xl" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} className="text-yellow-400 text-sm" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-600 mb-6 leading-relaxed relative z-10">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className={`w-12 h-12 ${getAvatarColor(index)} rounded-full flex items-center justify-center text-white font-bold flex-shrink-0`}>
                  {testimonial.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-bold text-secondary-dark truncate">{testimonial.name}</h4>
                  <p className="text-sm text-gray-500 truncate">{testimonial.role}</p>
                </div>
                <div className="text-xs text-gray-400 whitespace-nowrap">
                  {testimonial.date}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Google Reviews Link */}
        <div className="mt-12 text-center">
          <a
            href="https://www.google.com/maps/search/?api=1&query=Mecânica+Box+50+Araçariguama"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white hover:bg-gray-50 text-secondary-dark font-bold py-4 px-8 rounded-lg border-2 border-primary transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            <span>Ver Todas as Avaliações no Google</span>
          </a>
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-br from-secondary-dark via-black to-secondary rounded-2xl p-8 md:p-12 text-white border border-primary/20 shadow-2xl">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Faça Parte da Nossa História de Sucesso
            </h3>
            <p className="text-gray-200 mb-6 max-w-2xl mx-auto">
              Junte-se aos centenas de clientes satisfeitos que confiam em nosso trabalho. 
              Agende seu serviço hoje mesmo!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="#contato"
                className="inline-block bg-accent hover:bg-accent-dark text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105"
              >
                Agendar Serviço
              </a>
              <a
                href="#servicos"
                className="inline-block bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 border-2 border-white/30 hover:border-white/50"
              >
                Ver Serviços
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center">
            <div className="text-3xl font-bold text-accent mb-1">98%</div>
            <p className="text-sm text-gray-600">Taxa de Satisfação</p>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-accent mb-1">500+</div>
            <p className="text-sm text-gray-600">Clientes Atendidos</p>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-accent mb-1">10+</div>
            <p className="text-sm text-gray-600">Anos de Experiência</p>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-accent mb-1">100%</div>
            <p className="text-sm text-gray-600">Garantia</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
